import { setup } from 'axios-cache-adapter';
import { store } from '@/store/store';

export const api = setup({
  cache: {
    maxAge: 15 * 60 * 1000,
  },
  baseURL: 'https://linkmanager-stage.datacroft.de/api/v1/',
  paramsSerializer: (params) => params,
});

api.interceptors.response.use(undefined, (error) => {
  if (error.response && error.response.status === 401) {
    store.dispatch('auth/logout');
  }
  return Promise.reject(error);
});

export const clearCache = () => {
  api.cache.store = {};
};
